import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=43e8af3f&scoped=true&"
import script from "./privacy.vue?vue&type=script&lang=js&"
export * from "./privacy.vue?vue&type=script&lang=js&"
import style0 from "./privacy.vue?vue&type=style&index=0&id=43e8af3f&scoped=true&lang=css&"
import style1 from "./privacy.vue?vue&type=style&index=1&id=43e8af3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e8af3f",
  null
  
)

export default component.exports